import BirthdayBookingJson from "./BirthdayBookingJson";
import { BirthdayBookingStatus } from "./BirthdayBookingStatus";
import HolidayProgramBookingJson from "./HolidayProgramBookingJson";
import { HolidayProgramBookingStatus } from "./HolidayProgramBookingStatus";
import MemberJson from "./MemberJson";
import { MemberStatus } from "./MemberStatus";
import { MembershipType } from "./MembershipType";
import MembershipTermJson from "./MembershipTermJson";
import { MembershipRenewInterval } from "./MembershipRenewInterval";
import CustomerJson from "./CustomerJson";
import { Gender } from "./Gender";
import SepaMandateJson from "./SepaMandateJson";

const customer: CustomerJson = {
   ID: null,
   guardianFirstName: "Martin",
   guardianLastName: "Mustermann",
   guardianOrganisation: "",
   email: "demo@philbi.de",
   phone: "123456789",
   idDocuments: [],
   addressStreet: "Musterstraße 1",
   addressZip: "12345",
   addressCity: "Musterstadt",
   addressCountry: "Deutschland",
   childFirstName: "Maria",
   childLastName: "Mustermann",
   childBirthDate: "2005-05-23",
   childGender: Gender.female,
   childGradeLevel: 5,
   childSchoolClass: '',
   holidayBookingGroup: "",
   remarks: "",
};

const sepaMandate: SepaMandateJson = {
   ID: null,
   dateTime: "",
   lastUseDateTime: "",
   accountHolderFirstName: "",
   accountHolderLastName: "",
   addressStreet: "",
   addressZip: "",
   addressCity: "",
   addressCountry: "Deutschland",
   IBAN: "AT411100000237571500",
   BIC: "AAABBB12CCC"
};

export const BirthdayBookingForm: BirthdayBookingJson = {
   ID: null,
   beginDateTime: "",
   endDateTime: "",
   remarks: "",
   customer: customer,
   state: BirthdayBookingStatus.requestedStaffRequired,
   isStaffRequired: true,
   staffId: null,
   restrictStaffAssignmentIds: [],
   programCategory: "Tiergeburtstage",
   programTitle: "",
   programRemarks: "",
   location: "",
   estimatedChildrenCount: 6,
   price: null,
   cancellationFee: 0,
   cancellationRemarks: "",
   sepaMandate: sepaMandate,
   invoiceInfos: null
};

export const HolidayProgramBookingForm: HolidayProgramBookingJson = {
   ID: null,
   selectedDiscount: null,
   selectedDiscountInfo: "",
   selectedExtras: [],
   customers: [customer],
   allowedToComeAlone: false,
   allowedToGoAlone: false,
   authorizedToCollect: "",
   remarks: "",
   state: HolidayProgramBookingStatus.pending,
   price: null,
   cancellationFee: 0,
   cancellationRemarks: "",
   bookingDateTime: new Date().toISOString(),
   isSingleParent: false,
   isWorking: false,
   isPartnerWorking: false,
   isMarried: false,
   employerFirst: "",
   employerSecond: "",
   sepaMandate: sepaMandate,
   invoiceInfos: null
};

export const MemberForm: MemberJson = {
   ID: null,
   membershipType: MembershipType.normal,
   remarks: "",
   state: MemberStatus.requested,
   membershipTerms: [],
   customers: [customer],
   price: 0,
   renewInterval: MembershipRenewInterval.annual,
   sepaMandate: sepaMandate,
   creationDateTime: new Date().toISOString()
};